import { useQuery } from "react-query";
import dayjs from "dayjs";
import React, { memo, Suspense, useEffect, useMemo, useState } from "react";
import withLayout from "../../../src/layouts/withLayout";
import { newArticleCategory, fetchHotArticle } from "../../services/article_v2";
import { fetchArticleList } from "@Services/movie";
import { host } from "@Services/url";
import RelatedCar from "../tags/tagDetail/RelatedCar";
import { Skeleton } from "antd";
import Article from "@Components/article/categoryArticle/Article";
import MoviesShort from "@Components/movie/MoviesShort";
import NewCarArrival from "@Components/article/newCarArrival";
import SellingCar from "@Components/article/sellingCar";
import HotVideoList from "@Components/movie/Details/HotVideoList";
import HotArticle from "@Components/article/categoryArticle/HotArticle";

const RelevantKinds = React.lazy(() => import("@Components/common/RelevantKinds"));

const FeatureDescription = memo(({ description }: { description: string }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!!description) {
      setIsLoaded(true);
    }
  }, [description]);

  return (
    <>
      {!isLoaded ? (
        <Skeleton active />
      ) : (
        <div
          className="text-18 text-[#000000d9] leading-[1.5]"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </>
  );
});

const App: React.FC = ({ }) => {
  const [content, setContent] = useState(window.content || "");

  const navList = [
    {
      name: "推薦",
      link: `${host.c}/Articles`
    },
    {
      name: "新聞",
      link: `${host.c}/news`
    },
    {
      name: "試車",
      link: `${host.c}/trialrun`
    },
    {
      name: "導購",
      link: `${host.c}/Guide`
    },
    {
      name: "售後",
      link: `${host.c}/article/after-sale`
    },
    !!window.collectionId && {
      name: "特輯",
      link: `${host.c}/collection/list`
    },
    {
      name: "精華合輯",
      link: `${host.c}/feature`
    }
  ]

  const initState = {
    articleCount: 0,
    articleItems: [],
    articleMovies: [],
    content: "",
    description: "",
    id: 0,
    image: "",
    kindItems: [],
    shareLink: "",
    title: "",
    type: "",
    views: 0,
  };

  const { data: state = initState } = useQuery(
    [newArticleCategory.toString, window.FEATURE_ID],
    async () => {
      const res = await newArticleCategory({
        id: window.FEATURE_ID,
      });
      if (res && res.status === 12000) {
        // const regex = /(<a.*?>)(.*?)(<\/a>)/g;
        return {
          ...res.data,
          articleItems: res.data.articleItems.filter((item: { type: number }) => item.type !== 10),
          articleMovies: res.data.articleItems.filter((item: { type: number }) => item.type === 10),
          // content: res.data.content.replace(regex, '$1<span style="color: #1890ff;">$2</span>$3'),
        };
      }
      return initState;
    },
    {
      enabled: !!window.FEATURE_ID,
    },
  );

  useEffect(() => {
    var pageChange = {
      event: "pageChange",
      virtualPageUrl: location.pathname + location.search,
      dv_page: "文章列表",
      dv_channel: "文章",
      dv_category: "精華合輯",
    };

    if ("requestIdleCallback" in window) {
      requestIdleCallback(() => {
        window.dataLayer && window.dataLayer.push(pageChange);
      });
    } else {
      setTimeout(() => {
        window.dataLayer && window.dataLayer.push(pageChange);
      }, 3000);
    }

  }, []);

  useEffect(() => {
    if (!!window.content) {
      const updatedContent = window.content.replace(
        /<a(.*?)>(.*?)<\/a>/g,
        '<a$1 style="color: #1890ff;">$2</a>'
      );
      setContent(updatedContent);
    }
  }, [window.content]);

  const { articleItems, title, kindItems, type, articleMovies, id } = state;
  const { date, weekDay, city, weatherTemperatureValue, weatherDescription } = window.weather;

  if (!id) {
    return <Skeleton className="min-h-[80vh]" />
  }

  return (
    <section>
      <div className="bg-[#F4F4F4] leading-[50px]">
        <div className="flex w-[1190px] m-auto justify-between">
          <div className="flex gap-x-40">
            {navList.map((item, index) => (
              !!item && <a key={index} className="text-[#333] text-16" href={item.link} target="_blank">
                <span>{item.name}</span>
              </a>
            ))}
          </div>
          <div className="text-[#666666] text-12">
            <span>{date}</span>
            <span>{weekDay}</span>
            <span>{city}</span>
            <span>{weatherTemperatureValue}</span>
            <span>{weatherDescription}</span>
          </div>
        </div>
      </div>
      <div className="w-1190 m-auto">
        <div className="text-14 text-[#333] leading-20 mt-20">
          您當前的位置： <a href={`${host.c}/Models`}>新車首頁</a> &gt; <a href='/feature'>精華合輯</a> &gt;{" "}
          <span>{title}</span>
        </div>

        <div className="flex justify-center min-h-[100vh]">
          <div>
            <div className="w-full">
              {!!title && <h1 className="text-30 text-center text-[#333] leading-36 my-40 mx-20 font-[700]">{title}</h1>}
              {!!content && <FeatureDescription description={content} />}
            </div>

            <div style={{
              width: "886px",
              minHeight: kindItems.length > 0 && type === "article" ? "360px" : "0px",
              overflow: "hidden",
              transition: "min-height 0.3s ease"
            }}>
              {kindItems.length > 0 && type === "article" && (
                <RelatedCar
                  style={{ width: "886px", minHeight: "360px" }}
                  gaId={"Feature"}
                  source={"精華合輯詳情頁-相關車款"}
                  scrollNumber={[886, -732, 732]}
                  dataSource={kindItems}
                />
              )}
            </div>
            <div className="flex justify-between w-[886px]" style={{ minHeight: "100vh" }}>
              <ul className="mt-20 w-full">
                <React.Fragment>
                  {type === "movie" && articleMovies.length > 0 && (
                    <MoviesShort
                      dataSource={articleMovies}
                      urlParams={`?categoryId=${id}`}
                      itemCss={"mb-40 w-282"}
                      imgBoxCss={"w-282 h-374"}
                    />
                  )}
                  {articleItems.map((item, index) => (
                    <Article index={index} dataSource={item} dataSourceType={type} />
                  ))}
                </React.Fragment>
              </ul>
            </div>
          </div>
          <div className='ml-22' style={{ minHeight: "100vh" }}>

            {type === "article" ? (
              <>
                <NewCarArrival source='精華合輯頁-新車上市詢價' />
                <div className='w-284 min-h-[636px] bg-[#fff] border-solid border-1 border-color-[#e8e8e8] pt-18 px-16 mt-40 mb-30'>
                  <h3 className='text-24 font-medium text-[#333]'>熱銷車款</h3>
                  <SellingCar source='精華合輯頁-熱銷車款詢價' />
                </div>
                <HotArticle
                  title='熱門文章'
                  fetchData={fetchHotArticle}
                  fetchParams={{
                    limit: 10,
                    recommendType: "hot",
                  }}
                  style={{ border: "1px solid #e8e8e8", minHeight: "700px" }}
                />
              </>
            ) : (
              <div className='w-284'>
                <HotVideoList
                  title='最新影音'
                  mainClass='w-284'
                  imgClass='h-148'
                  request={fetchArticleList}
                  params={{ type: 3, limit: 3 }}
                  itemG4Class='NewVideoItem'
                />

                <HotVideoList
                  title='熱門影音'
                  mainClass='w-284'
                  imgClass='h-148'
                  itemG4Class='HotVideoItem'
                  request={fetchArticleList}
                  params={{
                    type: 3,
                    limit: 3,
                    sortBy: "hot",
                    gtTime: `${dayjs().subtract(1, "month").format("YYYY-MM-DD")} 00:00:00`,
                  }}
                />

                {kindItems.length > 0 && <Suspense fallback={<Skeleton active />}><RelevantKinds data={kindItems} askSource='影音合輯頁-相關車款-一鍵詢價' /></Suspense>}
              </div>
            )}

          </div>
        </div>
      </div>
    </section>
  );
};

withLayout({
  cmp: <App />,
  params: {
    webPageNav: true,
    nav: "",
    footer: "Footer",
  },
});
